import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoadingScreen } from "Components";
import { CreateStage } from "./CreateStage";
import { authService } from "Service/Axios";
import { convertLinkObjectListToJoin } from "Utils";
import { DELETE_STAGE_URL } from "Constant/api";
import { useStageList } from "Constant/apiHooks";

export const Stages = () => {
  const { t } = useTranslation();
  const { projectList } = useOutletContext();

  const [showCreateStage, setShowCreateStage] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);

  const { stageList, loading: stageLoading, fetchStageList } = useStageList();

  // Toggle
  const toggleCreateStage = (stage) => {
    if (stage) {
      setSelectedStage(stage);
    } else {
      setSelectedStage(null);
    }
    setShowCreateStage(!showCreateStage);
  };

  // Handle
  const onDeleteStage = async (gid, projectId) => {
    try {
      const data = {
        gid,
        projectId,
      };
      const response = await authService(DELETE_STAGE_URL, "POST", data);
      if (response.success) {
        fetchStageList();
        toast.success(t("common.messages.notification.success.deleteStage"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="stages">
        <div className="d-flex align-items-center mb-3">
          <h4 className="admin-sub-title">{t("common.button.stages")}</h4>
          <div className="ms-auto">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => toggleCreateStage()}
            >
              <i className="bx bx-plus"></i> {t("common.button.createStage")}
            </button>
          </div>
        </div>
        <div className="table-container mb-4 max-h-700">
          <table className="table table-bordered">
            <thead className="table-light position-sticky top-0 z-20">
              <tr>
                <th>{t("common.label.sequence")}</th>
                <th>{t("common.label.name")}</th>
                <th>{t("common.label.projects")}</th>
                <th className="text-center">{t("common.label.action")}</th>
              </tr>
            </thead>
            <tbody>
              {stageLoading ? (
                <tr className="loading-screen">
                  <td colSpan={4}>
                    <LoadingScreen />
                  </td>
                </tr>
              ) : (
                stageList &&
                stageList.length > 0 &&
                stageList.map((stage) => (
                  <tr key={stage.gid}>
                    <td>{stage.sequenceNo}</td>
                    <td>{stage.name}</td>
                    <td>
                      {stage.projects &&
                        convertLinkObjectListToJoin(stage.projects)}
                    </td>
                    <td>
                      <>
                        <div className="d-flex justify-content-center align-items-center gap-1">
                          <button
                            type="button"
                            className="button edit btn btn-transparent px-1 text-green-500"
                            onClick={() => toggleCreateStage(stage)}
                          >
                            <i className="bx bxs-pencil"></i>
                          </button>
                          <button
                            type="button"
                            className="button delete btn btn-transparent px-1 text-red-500"
                            onClick={() =>
                              onDeleteStage(stage.gid, stage.projectId)
                            }
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        </div>
                      </>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showCreateStage && (
        <CreateStage
          show={showCreateStage}
          selectedData={selectedStage}
          toggle={toggleCreateStage}
          fetchList={fetchStageList}
          projectList={projectList}
          stageList={stageList}
        />
      )}
    </>
  );
};
